import { render, staticRenderFns } from "./SetStatusModal.vue?vue&type=template&id=83ac845a&scoped=true&"
import script from "./SetStatusModal.vue?vue&type=script&lang=ts&"
export * from "./SetStatusModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83ac845a",
  null
  
)

export default component.exports